<template>
  <v-sheet class="cardDashboard" color="transparent">
    <v-row class="ma-0">
      <div
        :style="`${
          mdAndDown ? 'width: 100%' : `width: calc(100% - ${width}px);`
        }`"
      >
        <!-- SLIDER TIMELINE DE CLUSTERING IA -->
        <v-slider
          v-if="showTimeLineClustering"
          v-model="valueSliderMap"
          :max="12"
          :min="1"
          :step="1"
          thumb-label="always"
          class="mt-6"
          append-icon="mdi-plus"
          prepend-icon="mdi-minus"
          @click:append="addHours"
          @click:prepend="deleteHours"
        >
          <template v-slot:thumb-label="{ modelValue }">
            <v-sheet color="transparent" width="150">
              {{ season(modelValue) }}
            </v-sheet>
          </template>
        </v-slider>

        <div
          class="mapContainer"
          :style="`height:750px `"
          v-click-outside="{ handler: onClickOutside }"
          @click="activeClick"
        >
          <l-map
            ref="mapRef"
            class="mapClassBorder"
            :style="
              !active ? 'border: 0px solid white' : 'border: 4px solid white'
            "
            :zoom="zoomMap"
            :center="centerMap"
            @update:zoom="changezoom($event)"
            @update:center="changeCenter($event)"
            @ready="onMapReady"
            :options="{ zoomControl: false }"
          >
            <l-control-zoom :position="'topleft'"></l-control-zoom>

            <!-- MENU FLOTANTE DE FILTROS Y CHECKBOXES -->
            <l-control position="topright">
              <v-menu :close-on-content-click="false" location="end">
                <template v-slot:activator="{ props }">
                  <v-sheet class="iconMapButton">
                    <v-btn
                      color="black"
                      variant="text"
                      icon="mdi-menu"
                      v-bind="props"
                    ></v-btn>
                  </v-sheet>
                </template>

                <v-sheet
                  width="300"
                  max-height="550"
                  color="bgtopology"
                  class="datepickerContainer"
                >
                  <v-row v-if="!isChile" class="ma-2 mb-3">
                    <v-col class="pa-0" cols="12" sm="4" md="12">
                      <!-- Checkbox Mostrar Todo -->
                      <v-row class="ma-0 my-2">
                        <v-sheet
                          class="rowIcon pl-2 pt-0"
                          color="transparent"
                          height="40"
                          width="40"
                        >
                          <v-sheet
                            class="sheetNameIcon pb-1"
                            width="25"
                            height="25"
                          >
                            <v-icon size="small" color="white">mdi-eye</v-icon>
                          </v-sheet>
                        </v-sheet>
                        <v-sheet color="transparent" height="40" class="rowName">
                          <span>{{ t("checkBoxes.showAll") }}</span>
                        </v-sheet>
                        <v-checkbox
                          v-model="showALL"
                          color="success"
                          hide-details
                        />
                      </v-row>

                      <span v-if="showALL">
                        <!-- Checkbox PMPAP -->
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlyap"
                            />
                          </v-sheet>
                          <v-sheet color="transparent" height="40" class="rowName">
                            <span>{{ t("checkBoxes.showPMPAP") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPMPAP"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <!-- Checkbox PMPSM -->
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlypmp"
                            />
                          </v-sheet>
                          <v-sheet color="transparent" height="40" class="rowName">
                            <span>{{ t("checkBoxes.showPMPSM") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPMPSM"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <!-- Checkbox Rajant -->
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.IMAGES.onlysolar"
                            />
                          </v-sheet>
                          <v-sheet color="transparent" height="40" class="rowName">
                            <span>{{ t("checkBoxes.ShowRajant") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showRajant"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <!-- Checkbox Enlaces / Polilíneas -->
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <img
                              :height="'25'"
                              :src="CONSTANTIMGS.ICONS.links"
                            />
                          </v-sheet>
                          <v-sheet color="transparent" height="40" class="rowName">
                            <span>{{ t("checkBoxes.showLink") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showPolilynesBoolean"
                            color="success"
                            hide-details
                          />
                        </v-row>

                        <!-- Checkbox Nombres -->
                        <v-row class="ma-0 my-2">
                          <v-sheet
                            class="rowIcon pl-2 pt-0"
                            color="transparent"
                            height="40"
                            width="40"
                          >
                            <v-sheet
                              class="sheetNameIcon"
                              width="25"
                              height="25"
                            >
                              <span class="nameClassIcon">N</span>
                            </v-sheet>
                          </v-sheet>
                          <v-sheet color="transparent" height="40" class="rowName">
                            <span>{{ t("checkBoxes.showNames") }}</span>
                          </v-sheet>
                          <v-checkbox
                            v-model="showNames"
                            color="success"
                            hide-details
                          />
                        </v-row>
                      </span>

                      <!-- Checkbox Hexágonos Cluster -->
                      <v-row class="ma-0 my-2">
                        <v-sheet
                          class="rowIcon"
                          color="transparent"
                          height="40"
                          width="40"
                        >
                          <img
                            :height="'25'"
                            :src="CONSTANTIMGS.ICONS.circles"
                          />
                        </v-sheet>
                        <v-sheet color="transparent" height="40" class="rowName">
                          <span>Clusters</span>
                        </v-sheet>
                        <v-checkbox
                          v-model="showCircleCluster"
                          color="success"
                          hide-details
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-else class="ma-0 mb-3">
                    <v-col class="pa-0" cols="12" sm="4" md="12">
                      <v-checkbox
                        v-model="showNames"
                        color="success"
                        :label="t('checkBoxes.showNames')"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-menu>
            </l-control>

            <!-- LAYER MAPA BASE -->
            <l-tile-layer :url="finalURL"></l-tile-layer>

            <!-- 1. RENDERING DE ENLACES (POLILINEAS DINAMICAS ENTRE NODOS VISIBLES) -->
           <l-polyline
            v-for="(line, idx) in activePolylines"
            :key="'poly-' + idx"
            :lat-lngs="line.path"
            :color="line.colorLine"
            :weight="3"
            :opacity="0.8"
          ></l-polyline>

            <!-- 2. RENDERING DE MARCADORES UNIFICADOS (SIMPLES, DOBLES O TRIPLES) -->
            <l-marker
              v-for="cluster in renderClusters"
              :key="cluster.id"
              :lat-lng="cluster.position"
            >
              <!-- Ícono Representativo según la combinación del grupo -->
              <l-icon :icon-size="[60, 60]" :icon-anchor="[35, 30]">
                <v-sheet color="transparent" :width="70" class="text-center">
                  <img :height="'30'" :src="cluster.compositeImage" />

                  <!-- Etiqueta de Nombre(s) si showNames está activo -->
                  <template v-if="showNames">
                    <v-sheet
                      v-for="dev in cluster.devices"
                      :key="'name-' + dev.ip"
                      :class="'classnameIcon mb-1 ' + getColorCard(dev.status)"
                      @click.stop="onDeviceClick(dev)"
                    >
                      <h5>{{ dev.name }}</h5>
                    </v-sheet>
                  </template>
                </v-sheet>
              </l-icon>

              <!-- TOOLTIP CON MÉTRICAS AL PASAR EL MOUSE POR ENCIMA -->
              <l-tooltip
                :options="{
                  permanent: false,
                  interactive: true,
                  direction: 'right',
                }"
              >
                <v-sheet
                  class="sheetTooltip text-center"
                  color="#9fa09f"
                  :min-width="widthToolTip"
                >
                  <div
                    v-for="(dev, dIdx) in cluster.devices"
                    :key="'tooltip-' + dev.ip"
                    class="pa-1"
                  >
                    <!-- Título con Estado del Equipo -->
                    <v-sheet
                      :color="getColorSheet(dev.status)"
                      class="text-caption font-weight-bold px-1"
                    >
                      {{ dev.name }} ({{ dev.tipo }})
                    </v-sheet>

                    <!-- Renderizado de Latencia, RXLVL y SNR -->
                    <div v-html="getInfoInToMap(dev.ip)" />

                    <!-- Separador si el grupo tiene múltiples equipos -->
                    <v-divider
                      v-if="dIdx < cluster.devices.length - 1"
                      class="my-1"
                      color="white"
                    ></v-divider>
                  </div>
                </v-sheet>
              </l-tooltip>
            </l-marker>
          </l-map>

          <v-sheet v-if="!active" class="mapTest"></v-sheet>
        </div>

        <!-- LEYENDA Y RANGOS DE VELOCIDAD/LATENCIA -->
        <v-sheet
          class="mt-5"
          width="100%"
          color="transparent"
          style="align-content: center"
        >
          <v-row class="ma-0" :justify="smAndDown ? 'center' : 'space-between'">
            <v-sheet color="transparent" :width="mdAndDown ? '100%' : 360">
              <v-row class="ma-0" :justify="mdAndDown ? 'center' : 'start'">
                <v-icon> mdi-speedometer </v-icon>
                <span class="ml-2 mt-0 legendMapDash">
                  {{ t("labels.latency") }} |
                  <span> {{ t("labels.redSpeed") }}</span>
                </span>
              </v-row>
            </v-sheet>
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.green"
              :secundary-color="'rgb(62 97 57)'"
              :color-text-princ="'white'"
              :color-text-secun="'white'"
              :principal-text="t('labels.ok')"
              :secundary-text="'0 a 100 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.yellow"
              :secundary-color="'#B4A343'"
              :color-text-princ="'black'"
              :color-text-secun="'white'"
              :principal-text="t('labels.alert')"
              :secundary-text="'100 a 500 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
            <rangeComponent
              :class="smAndDown ? 'mt-2' : 'mt-0'"
              :principal-color="COLOR.red"
              :secundary-color="'#8F3A36'"
              :color-text-princ="'white'"
              :color-text-secun="'white'"
              :principal-text="t('labels.alarm')"
              :secundary-text="'Mayor a 500 ms'"
              :sheetWidth="smAndDown ? 350 : 225"
            />
          </v-row>
        </v-sheet>
      </div>

      <!-- PANEL DE MENSAJES Y FILTROS LATERAL -->
      <v-sheet
        v-if="showFilters"
        color="transparent"
        :class="mdAndDown ? 'pa-0 pt-4' : 'pl-4'"
        :style="mdAndDown ? 'text-align: -webkit-center;' : ''"
        :width="mdAndDown ? '100%' : width"
      >
        <MessageComponent :recurrent-alarms="recurrentAlarms" />
      </v-sheet>
    </v-row>
  </v-sheet>

  <!-- DIÁLOGO DETALLE DE EQUIPO AL HACER CLIC -->
  <v-dialog v-model="dialog" width="85%">
    <DialogComponent
      v-if="dialog"
      :ip="selectedIp"
      :typeSel="selectedType"
      :name="selectedName"
      :status="finalStatus"
      @dialog="closeDialog"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import {
  Ref,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
  toRaw,
} from "vue";
import type { PropType } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
const { smAndDown, mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import MessageComponent from "@/components/SmartLink/dashboard/MessageComponent.vue";
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

/********************************
 *********** LEAFLET ************
 *******************************/
import {
  LMap,
  LTileLayer,
  LPolyline,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LControl,
} from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
if (typeof window !== "undefined") {
  window.L = L;
}
import "leaflet.heat";

/********************************
 ********** CONSTANTES **********
 *******************************/
import {
  LABELS,
  NAME_PROJECT,
  STRING_GENERAL,
} from "@/constants/labels";
import CONSTANTIMGS from "@/constants/images";
import { COLOR } from "@/constants/colors";
import CONSTMAPS from "@/constants/maps";

/********************************
 ********** INTERFACES **********
 *******************************/
import { POSITION, CIRCLE, CLUSTERING } from "@/interfaces/SmartLink/Map";
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { STRINGS } from "@/interfaces/SmartLink/General";
import { PointExpression } from "leaflet";// NetworkChart.vue (<script setup lang="ts">)
import { ALARMTYPE } from "@/interfaces/SmartLink/KPI";

/********************************
 *********** UTILS **************
 *******************************/
import {
  getStatusByLatency,
  getStatusBySNR,
  getStatusByRXLVL,
  getFinalStatusByStatitics,
} from "@/functions/maps";

import {
  groupVisibleDevices,
  buildActiveLinks,
  NetworkDevice,
  ClusteredMarker,
} from "@/utils/SmartLink/mapClustering";

// --- PROPS CENTRALIZADAS (REEMPLAZAN LAS LLAMADAS A API) ---
const props = defineProps({
  latLngSm: { type: Array as PropType<EQUIPAMENTS[]>, default: () => [] },
  latLngRaj: { type: Array as PropType<EQUIPAMENTS[]>, default: () => [] },
  latLngAp: { type: Array as PropType<any[]>, default: () => [] },
  polylinesData: { type: Array as PropType<any[]>, default: () => [] },
  rxlvlSnrData: { type: Array as PropType<any[]>, default: () => [] },
  latencyData: { type: Array as PropType<any[]>, default: () => [] },
  hexagonData: { 
    type: [Object, null] as PropType<Record<string, any> | null>, 
    default: null 
  },
  recurrentAlarms: { type: Array as PropType<ALARMTYPE[]>, default: () => [] }
});

// --- ESTADOS Y REACTIVIDAD ---
const active = ref(false);
const projectName = computed(() => store.state.projectName);
const isChile = ref(
  projectName.value === "SmartLinkAntucoya" ||
    projectName.value === "SmartLinkZaldivar",
);
const finalURL = ref("");
const width = ref("350");
const widthToolTip = ref("100");

const zoomMap = computed(() => CONSTMAPS.zoom.value);
const centerMap: Ref<PointExpression> = ref([
  CONSTMAPS.latitud.value,
  CONSTMAPS.longitud.value,
]);

// Controles de Visualización
const showALL = ref(true);
const showPMPAP = ref(true);
const showPMPSM = ref(true);
const showRajant = ref(true);
const showPolilynesBoolean = ref(true);
const showNames = ref(true);
const showCircleCluster = ref(true);
const showTimeLineClustering = ref(false);
const showFilters = ref(true);

// Diálogo
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const finalStatus = ref("Ok");

// Colección general de datos puros asignados desde las Props
const elementPMPSM = computed(() => props.latLngSm);
const elementRAJANT = computed(() => props.latLngRaj);
const rawPMPAPItems = computed(() => props.latLngAp);
const rawPolylinesList = computed(() => props.polylinesData);

// Colecciones consolidadas
const allNetworkDevices: Ref<NetworkDevice[]> = ref([]);
const renderClusters: Ref<ClusteredMarker[]> = ref([]);
const activePolylines: Ref<any[]> = ref([]);

const allFinalStatiticsItems: any = ref({});
const allFinalStatusItems: any = ref({});
const pointsClustering: Ref<CLUSTERING[]> = ref([]);
const valueSliderMap = ref(12);
const arrayDatesClustering: Ref<string[]> = ref([]);
const totalClusteringData: Ref<CLUSTERING[]> = ref([]);

const mapInstance: any = ref(null);
let heatLayer: any = null;
let geoJsonLayer: any = null;

const COLORSTATUS: STRINGS = {
  OK: "green",
  ALERT: "yellow",
  ALARM: "red",
  DOWN: "#353634",
};

watch(smAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

// ================================================== //
// ================= CLUSTERING LOGIC =============== //
// ================================================== //

const updateMapVisualization = () => {
  if (!showALL.value) {
    renderClusters.value = [];
    activePolylines.value = [];
    return;
  }

  const visibleDevices = allNetworkDevices.value.filter((dev) => {
    if (dev.tipo === "PMPAP" && showPMPAP.value) return true;
    if (dev.tipo === "PMPSM" && showPMPSM.value) return true;
    if (dev.tipo === "RAJANT" && showRajant.value) return true;
    return false;
  });

  renderClusters.value = groupVisibleDevices(
    visibleDevices,
    0.0005,
    CONSTANTIMGS
  );

  if (showPolilynesBoolean.value) {
    activePolylines.value = buildActiveLinks(
      visibleDevices,
      rawPolylinesList.value
    );
  } else {
    activePolylines.value = [];
  }
};

watch(
  [showALL, showPMPAP, showPMPSM, showRajant, showPolilynesBoolean],
  () => {
    updateMapVisualization();
  },
  { deep: true },
);

// ================================================== //
// ================= PROCESAMIENTO DE DATOS ========= //
// ================================================== //

function getStatusByIP(ip: string) {
  if (!allFinalStatusItems.value[ip]) {
    return "down";
  }
  return allFinalStatusItems.value[ip].status;
}

function processRXLVLSNRData() {
  if (!props.rxlvlSnrData) return;
  props.rxlvlSnrData.forEach((item: any) => {
    if (allFinalStatiticsItems.value[item.ip]) {
      allFinalStatiticsItems.value[item.ip].snrv = getStatusBySNR(item.snrv);
      allFinalStatiticsItems.value[item.ip].snrh = getStatusBySNR(item.snrh);
      allFinalStatiticsItems.value[item.ip].rxlvlh = getStatusByRXLVL(item.rxlvlh);
      allFinalStatiticsItems.value[item.ip].rxlvlv = getStatusByRXLVL(item.rxlvlv);
      allFinalStatiticsItems.value[item.ip].snrvValue = item.snrv;
      allFinalStatiticsItems.value[item.ip].snrhValue = item.snrh;
      allFinalStatiticsItems.value[item.ip].rxlvlhValue = item.rxlvlh;
      allFinalStatiticsItems.value[item.ip].rxlvlvValue = item.rxlvlv;
    }
  });
}

function processLatencyData() {
  if (!props.latencyData) return;
  props.latencyData.forEach((item: any) => {
    if (!allFinalStatiticsItems.value[item.ip]) {
      allFinalStatiticsItems.value[item.ip] = {};
    }
    allFinalStatiticsItems.value[item.ip].latencia = getStatusByLatency(item.latencia);
    allFinalStatiticsItems.value[item.ip].latenciaValue = item.latencia;
    allFinalStatiticsItems.value[item.ip].fecha = item.fecha;
  });
}

const extractNumberFromName = (name: string, tipo: string): string => {
  if (!name) return "";

  if (
    projectName.value === NAME_PROJECT.cananea ||
    projectName.value === NAME_PROJECT.demo ||
    projectName.value === NAME_PROJECT.nacozari
  ) {
    if (tipo === "RAJANT") return name.split("-")[0] || "";
    if (tipo === "PMPSM") return name.split("M")[1] || "";
  }

  if (projectName.value === NAME_PROJECT.collahuasi) {
    if (tipo === "RAJANT") return name.split("-")[2] || "";
    if (tipo === "PMPSM") return name.split("-")[3] || "";
  }

  const match = name.match(/\d+/);
  return match ? match[0] : "";
};

const buildConsolidatedDevices = async () => {
  const list: NetworkDevice[] = [];
  const rajantCoordsByNumber = new Map<string, [number, number]>();

  elementRAJANT.value.forEach((element: EQUIPAMENTS) => {
    const rajNum = extractNumberFromName(element.name ?? "", "RAJANT");
    const lat = element.latitud ?? 0;
    const lng = element.longitud ?? 0;

    if (rajNum && (lat !== 0 || lng !== 0)) {
      rajantCoordsByNumber.set(rajNum, [lat, lng]);
    }

    list.push({
      ip: element.ip ?? "",
      name: element.name ?? "",
      tipo: "RAJANT",
      position: [lat, lng],
      status: getStatusByIP(element.ip ?? ""),
    });
  });

  elementPMPSM.value.forEach((pmpsm: EQUIPAMENTS) => {
    const smNum = extractNumberFromName(pmpsm.name ?? "", "PMPSM");
    let finalPosition: [number, number] = [
      pmpsm.latitud ?? 0,
      pmpsm.longitud ?? 0,
    ];

    let anotacion: any = pmpsm.anotacion !== null ? pmpsm.anotacion ?? {} : {};
    
    if (anotacion.gps) {
      const matchRaj = elementRAJANT.value.find((r) => r.ip === anotacion.gps);
      if (matchRaj) {
        finalPosition = [matchRaj.latitud ?? 0, matchRaj.longitud ?? 0];
      }
    } else if (smNum && rajantCoordsByNumber.has(smNum)) {
      finalPosition = rajantCoordsByNumber.get(smNum)!;
    }

    list.push({
      ip: pmpsm.ip ?? "",
      name: pmpsm.name ?? "",
      tipo: "PMPSM",
      position: finalPosition,
      status: getStatusByIP(pmpsm.ip ?? ""),
    });
  });

  rawPMPAPItems.value.forEach((element: EQUIPAMENTS) => {
    let finalLat = element.gps?.latitud ?? element.latitud ?? 0;
    let finalLng = element.gps?.longitud ?? element.longitud ?? 0;

    if (
      element.name?.includes(STRING_GENERAL.PMPAP1) ||
      element.name?.includes(STRING_GENERAL.PMPAP5)
    ) {
      finalLat = (element.longitud ?? 0) + 0.000512;
      finalLng = (element.latitud ?? 0) - 0.000512;
    }

    list.push({
      ip: element.ip ?? "",
      name: element.name ?? "",
      tipo: "PMPAP",
      position: [finalLat, finalLng],
      status: getStatusByIP(element.ip ?? ""),
    });
  });

  allNetworkDevices.value = list;
};

async function processAllMapInfo() {
  allFinalStatiticsItems.value = {};
  processLatencyData();
  processRXLVLSNRData();
  allFinalStatusItems.value = await getFinalStatusByStatitics(
    allFinalStatiticsItems.value,
  );
  await buildConsolidatedDevices();
  updateMapVisualization();
}

// Reactividad directa en respuesta a la orquestación central
watch(
  () => [props.latLngSm, props.latLngRaj, props.latencyData, props.rxlvlSnrData],
  async () => {
    await processAllMapInfo();
  },
  { deep: true, immediate: true }
);

// ================================================== //
// ================= MAP HELPERS & UI =============== //
// ================================================== //

const onClickOutside = () => (active.value = false);
const activeClick = () => (active.value = true);

const onMapReady = (mapObject: any) => {
  mapInstance.value = mapObject;
};

function getInfoInToMap(ip: string) {
  const itemData = allFinalStatiticsItems.value[ip];

  if (!itemData) {
    return `<p>Sin datos de métricas</p>`;
  }

  let htmlInMap = "";

  const isValidMetric = (val: any): boolean => {
    return val !== undefined && val !== null && val !== "" && !isNaN(Number(val));
  };

  if (isValidMetric(itemData.latenciaValue)) {
    htmlInMap += `<p>Latencia : ${itemData.latenciaValue} ms</p>`;
  }
  if (isValidMetric(itemData.rxlvlhValue)) {
    htmlInMap += `<p>RXLVL-H : ${itemData.rxlvlhValue} dBm</p>`;
  }
  if (isValidMetric(itemData.rxlvlvValue)) {
    htmlInMap += `<p>RXLVL-V : ${itemData.rxlvlvValue} dBm</p>`;
  }
  if (isValidMetric(itemData.snrhValue)) {
    htmlInMap += `<p>SNRH : ${itemData.snrhValue} dB</p>`;
  }
  if (isValidMetric(itemData.snrvValue)) {
    htmlInMap += `<p>SNRV : ${itemData.snrvValue} dB</p>`;
  }

  if (htmlInMap === "") {
    htmlInMap = `<p>Sin información disponible</p>`;
  }

  return htmlInMap;
}

const getColorSheet = (status: string) => {
  const st = (status || "").toUpperCase();
  if (st === "OK") return "green";
  if (st === "ALERT") return "yellow";
  if (st === "ALARM") return "red";
  return "#505150";
};

const getColorCard = (status: string) => {
  const st = (status || "").toUpperCase();
  if (st === "OK") return "greenSheet";
  if (st === "ALERT") return "yellowSheet";
  if (st === "ALARM") return "redSheet";
  return "greySheet";
};

const showDialog = (
  ip: string,
  type: string,
  name: string,
  status: string,
) => {
  dialog.value = !dialog.value;
  selectedName.value = name;
  selectedIp.value = ip;
  selectedType.value = type;
  finalStatus.value = status;
};

const closeDialog = (value: boolean) => {
  dialog.value = value;
};

const onDeviceClick = (device: NetworkDevice) => {
  showDialog(device.ip, device.tipo, device.name, device.status);
};

const changezoom = (e: number) => store.commit("setProjectZOOM", e);
const changeCenter = (center: any) => {
  store.commit("setProjectLAT", center.lat);
  store.commit("setProjectLNG", center.lng);
};

// Heatmap y Hexagon
const actualizarHeatmap = async () => {
  if (!mapInstance.value) return;
  const map: any = toRaw(mapInstance.value);
  if (heatLayer) map.removeLayer(heatLayer);

  const puntosCalor: any[] = [];
  pointsClustering.value.forEach((p: any) => {
    if (p.latitud !== 0 && p.longitud !== 0) {
      puntosCalor.push([p.latitud, p.longitud, 0.3]);
    }
  });

  heatLayer = L.heatLayer(puntosCalor, {
    radius: 17,
    blur: 2,
    maxZoom: 15,
    gradient: { 0.6: "yellow", 1: "red" },
  });

  map.addLayer(heatLayer);
};

watch(pointsClustering, () => actualizarHeatmap(), { deep: true });

function renderHexagonInMap() {
  if (!props.hexagonData) return;
  if (geoJsonLayer && mapInstance.value) {
    mapInstance.value.removeLayer(geoJsonLayer);
  }
  
  geoJsonLayer = L.geoJSON(props.hexagonData as any, {
    style: (feature: any) => ({
      color: "white",
      weight: 1,
      fillColor: feature.properties.color,
      fillOpacity: 0.6,
    }),
    onEachFeature: (feature: any, layer: any) => {
      const p = feature.properties;
      const popupContent = `
        <div style="text-align:center">
          <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
          <hr style="margin:5px 0">
          <b>Muestras:</b> ${p.muestras}<br>
          <b>Fallos:</b> ${p.fallos}<br>
        </div>`;
      layer.bindPopup(popupContent);
    },
  });

  if (mapInstance.value && showCircleCluster.value) {
    geoJsonLayer.addTo(mapInstance.value);
  }
}

watch(() => props.hexagonData, () => renderHexagonInMap(), { immediate: true });

watch(showCircleCluster, (value: boolean) => {
  if (geoJsonLayer && mapInstance.value) {
    if (value) {
      geoJsonLayer.addTo(mapInstance.value);
    } else {
      mapInstance.value.removeLayer(geoJsonLayer);
    }
  }
});

const season = (val: number) => arrayDatesClustering.value[val - 1];
const addHours = () => {
  if (valueSliderMap.value < 12) valueSliderMap.value++;
};
const deleteHours = () => {
  if (valueSliderMap.value > 1) valueSliderMap.value--;
};

onMounted(async () => {
  finalURL.value =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  await processAllMapInfo();
});

onBeforeUnmount(() => {
  if (mapInstance.value && heatLayer) {
    const map: any = toRaw(mapInstance.value);
    map.removeLayer(heatLayer);
  }
});
</script>

<style>
.LabelPMPSM {
  color: #003f7f !important;
  font-weight: bold;
  text-shadow: 1px 1px 1px black;
  /* margin-top: 20px !important; */
}

.LabelPMPAP {
  color: #d81e1e !important;
  font-weight: bold;
  text-shadow: 1px 1px 0.5px black;
  /* margin-top: 20px !important; */
}

.LabelRAJANT {
  color: green !important;
  font-weight: bold;
  /* margin-top: 20px !important; */
}

.leaflet-marker-icon {
  /* margin-left: 0 !important;
    margin-top: 0 !important;
    width: 50px !important;
    height: 100px !important; */
  background-color: transparent !important;
  border: none !important;
}
.classDown {
  filter: drop-shadow(4px 4px 5px rgb(41, 41, 41));
  display: block;
  max-width: 100%;
}
/* .leaflet-container {
    border-radius: 10px;
}
.leaflet-container:hover {
    border: 1px solid rgba(255,255,255,0.5);
} */
.mapClassBorder {
  border-radius: 10px;
  border-color: rgba(255, 255, 255, 0.9);
  /* border-width: 10px; */
}
/* .mapClassBorder:hover {
} */
.mapActiveClassBorder {
  border-radius: 15px;
  border: 4px solid rgba(255, 255, 255, 0.5);
}

.leaflet-tooltip-right {
  margin-left: 15px !important;
}

.leaflet-tooltip {
  padding: 0px !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 10px !important;
}
.leaflet-tooltip-right:before {
  border-right-color: #9fa09f !important;
}
.sheetTooltip {
  border-radius: 10px;
  padding: 5px;
}
.classnameIcon {
  border-radius: 5px;
  width: 70px;
  overflow: hidden;
  border: 1px solid #000;
}
.greenSheet {
  background-color: rgba(2, 101, 2, 0.8);
  color: white;
}
.redSheet {
  background-color: rgba(219, 6, 6, 0.8);
  color: white;
}
.yellowSheet {
  background-color: rgba(238, 255, 2, 0.8);
  color: black;
}
.greySheet {
  background-color: rgba(87, 87, 87, 0.8);
  color: white;
}
.iconStatusCard {
  border-radius: 50%;
}

.rowIcon {
  align-content: center !important;
  text-align: center !important;
  padding-top: 4px;
}
.rowIcon .trueIcon {
  border-radius: 10px;
  border: 1px solid #ffffff;
}
.rowName {
  align-content: center !important;
  min-width: calc(100% - 80px);
}

.namePopUP {
  font-size: 16px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.namePopUP:hover {
  font-weight: bolder;
  cursor: pointer;
}

.sheetNameIcon {
  border: 1px solid white;
  border-radius: 3px;
  background-color: green;
}

.nameClassIcon {
  font-size: 17px;
  color: white;
}

.iconMapButton {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
}

.legendMapDash {
  font-size: 14px;
  text-transform: uppercase;
  /* letter-spacing: 1px; */
  padding-top: 1px;
}

.legendMapDash span {
  text-transform: capitalize;
}

.mapContainer {
  position: relative;
}

.mapTest {
  height: 750px;
  width: 100%;
  position: absolute;
  z-index: 1000;
  top: 0%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
.mapTest:hover {
  border: 3px solid rgba(255, 255, 255, 0.5);
}


.custom-marker-container {
  background: transparent !important;
  border: none !important;
}

.marker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* EL PUNTO: Un solo color fijo (ej. Azul) */
.marker-dot {
  width: 14px;
  height: 14px;
  background-color: #007bff; /* Color Único Fijo */
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 2px;
}

/* La etiqueta de texto */
.marker-label {
  font-size: 10px;
  font-weight: bold;
  color: #333;
  background: rgba(255, 255, 255, 0.9);
  padding: 1px 4px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
</style>
